import { type ReactNode } from 'react';

type LegalArticleProps = {
  readonly children: ReactNode;
  readonly intro?: string;
  readonly title: string;
};

export function LegalArticle({ children, intro, title }: LegalArticleProps) {
  return (
    <article className="mx-auto flex w-full max-w-3xl flex-col gap-6 rounded-xl bg-white p-6 shadow-lg md:p-12">
      <h1 className="text-3xl font-semibold break-words text-tiga-text-default">
        {title}
      </h1>
      {intro === undefined ? null : (
        <p className="text-sm text-gray-600">{intro}</p>
      )}
      {children}
    </article>
  );
}

type LegalSectionProps = {
  readonly children: ReactNode;
  readonly heading: string;
};

export function LegalSection({ children, heading }: LegalSectionProps) {
  return (
    <section className="flex flex-col gap-1">
      <h2 className="text-lg font-medium break-words text-tiga-text-default">
        {heading}
      </h2>
      {children}
    </section>
  );
}
